<form #contactForm="ngForm" style="display:inline" [ngClass]="{'_load-animate _load-active': loadingCustomer}">

	<!--<button mat-fab mat-dialog-close cdkFocusInitial class="loyalty-close" color="primary" (mousedown)="close()" *ngIf="wizardStep != stepsMap.requiered && wizardStep != stepsMap.terms_missing && wizardStep > 3">
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>

	<button  type="button" class="o-btn _xl _shadow brand-accent btn-block btn-close-outside"
			 *ngIf="wizardStep < 3"
			 (mousedown)="close(club)">
		<span>{{($storage.config?.settings.clubMethod == 'voucher' ? '_LOYALTY.not_interested_voucher' : '_LOYALTY.not_interested_club') | translate}}</span>
	</button>-->

	<div class="_dialog-title">
		<mat-icon svgIcon="logo" class="mr-2"></mat-icon>
		<span>{{title}}</span>
	</div>

	<div class="_dialog-content" >
		<mat-tab-group class="wiz-tabs hide-headers" [selectedIndex]="wizardStep" [dynamicHeight]="true">
			<!------------------------------------------------------------------------------------->
			<!--LOYALTY CLUBS-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				@if ($storage.loyaltyClubs[1]) {
					<div>
						<button mat-raised-button color="accent" class="lg mt-3 btn-block main-continue-btn" type="button"
								*ngFor="let club of $storage.loyaltyClubs | slice:0:5"
								(mousedown)="selectClub(club)">
							{{club.name}}
						</button>
					</div>
					<div class="_bottom-actions mt-4">
						<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
						<button type="button" mat-flat-button color="accent" class="rounded" disabled style="min-width: 120px">{{'continue' | translate}}</button>
					</div>
				} @else {
					<div [ngClass]="{'_load-animate _load-active': !loadingCustomer}" style="min-height: 200px">

					</div>
				}
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--LOYALTY LOGIN-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				<div #pasteTarget style=" margin:0 auto">
					<div class="_sub-title pre-wrap" *ngIf="$storage.loyaltyHeaderSubCaption">{{($storage.loyaltyHeaderSubCaption || '_LOYALTY.loginSubCaption') | translate}}</div>
					<div class="keypad-val-container">
						<div class="keypad-val brand-input-border" [class._hasVal]="ui.connectValue?.length">
							<div class="_cap">{{'_LOYALTY.connect_info' | translate}}</div>
							<div class="_val" [class.text-danger]="ui.connectOptions.invalid">{{ui.connectValue}}</div>
						</div>
					</div>
					<app-inline-keypad #loginKeypad [data]="ui.connectOptions" (onChange)="onPhoneKeyChange($event)"></app-inline-keypad>

					<!--<div class="text-center">
						<button class="o-btn _xl " type="button" (mousedown)="onPhoneAlphaNumClick()">
							{{'_LOYALTY.code_with_letters' | translate}}
						</button>
					</div>-->
				</div>

				<div class="_bottom-actions mt-4">
					<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
					<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="getCustomer()" [disabled]="!ui.connectValid" style="min-width: 120px">{{'continue' | translate}}</button>
				</div>

			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--LOYALTY LOGIN_AUTH-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				<div style="margin:0 auto">
					<div class="_sub-title pre-wrap">{{'_LOYALTY.auth_sub_title' | translate}}</div>
					<div class="keypad-val-container">
						<div class="keypad-val brand-input-border" [class._hasVal]="ui.authValue?.length">
							<div class="_cap">{{'_LOYALTY.auth_code' | translate}}</div>
							<div class="_val" [class.text-danger]="!ui.authValid">{{ui.authValue}}</div>
						</div>
					</div>
					<app-inline-keypad [data]="ui.auth_connectOptions" (onChange)="onAuthKeyChange($event)" *ngIf="!ui.loadingAuth"></app-inline-keypad>
					<div class="_sub-footer text-center text-accent mt-3" (click)="authResend()">{{'_LOYALTY.auth_resend' | translate}}</div>
				</div>

				<div class="_bottom-actions mt-4">
					<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
					<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="authCustomer()" [disabled]="!ui.authValid" style="min-width: 120px">{{'continue' | translate}}</button>
				</div>
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--LOYALTY TERMS MISSING-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				@if (wizardStep == stepsMap.terms_missing) {
					<div class="mb-3">{{ '_LOYALTY_REG.terms_required_description' | translate }}</div>

					<app-loyalty-registration-form #regFields [source]="registerFields"
												   [fields]="$storage.loyaltyClub.regInfo.requiredFields"
												   [required]="true"></app-loyalty-registration-form>
					<div class="mb-3">
						<div class="mb-3" *ngIf="$storage.loyaltyClub?.regInfo?.termsFile">
							<div>
								<mat-checkbox [(ngModel)]="terms.readContract" name="readContract"
											  [color]="warn">
                                          <span style="white-space:pre-line"
												[class.text-danger]="!terms.readContract && ui.contractWarning">
                                              {{ $storage.loyaltyClub?.regInfo?.textForConfirmClubRules || ('_LOYALTY_REG.registration_contract' | translate) }}
                                          </span>
								</mat-checkbox>
							</div>
							<a class="a-link ml-2" (click)="openRegContract()"
							   style="display:block; font-weight:600">
								{{ '_LOYALTY_REG.read_contract' | translate }}
							</a>
						</div>
						<div>
							<mat-checkbox [(ngModel)]="terms.acceptTerms" name="acceptTerms" [color]="warn">
										<span style="white-space:pre-line"
											  [class.text-danger]="!terms.acceptTerms && ui.regWarning">{{ $storage.loyaltyClub?.regInfo?.textForConfirmSms || ('_LOYALTY_REG.registration_terms' | translate) }}</span>
							</mat-checkbox>
						</div>

						@if (loyaltyService.loyaltyMember?.workFlow != 'none' && $storage.loyaltyClub?.regInfo?.clubRegMessage) {
							<div class="mb-3">{{ $storage.loyaltyClub.regInfo.clubRegMessage }}</div>
						}
					</div>

					<div class="_bottom-actions d-flex align-items-center mt-3">
						<button mat-button color="accent" (mousedown)="skipTerms()">{{ '_LOYALTY_REG.no_thanks' | translate }}
						</button>
						<div class="flex-grow-1"></div>
						<button type="button" mat-flat-button color="accent" class="rounded"
								(mousedown)="updateTerms()"
								style="min-width: 120px">{{ 'continue' | translate }}
						</button>
					</div>
				}
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--ACCOUNT UPDATE-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				@if (wizardStep == stepsMap.account_update) {

					<div class="pre-wrap">{{ '_LOYALTY_REG.after_reg_add_details_description' | translate }}</div>
					<app-loyalty-registration-form #regOptionalFields
												   [source]="registerOptionalFields"
												   [fields]="$storage.loyaltyClub.regInfo.optionalFields"
												   [required]="false"></app-loyalty-registration-form>

					<div class="_bottom-actions d-flex align-items-center mt-3">
						<button mat-button color="accent"
								(mousedown)="afterRegSkip()">{{ '_LOYALTY_REG.another_time' | translate }}
						</button>
						<div class="flex-grow-1"></div>
						<button type="button" mat-flat-button color="accent" class="rounded"
								(mousedown)="afterRegUpdate()"
								style="min-width: 120px">{{ 'continue' | translate }}
						</button>
					</div>
				}
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--REQUIERED OFFERS-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				@if (wizardStep == stepsMap.requiered) {

					@if (requiereInvitation) {
						<div class="mb-3">{{ '_LOYALTY_REG.sms_additional_info_sent_update' | translate }}</div>
					}
					@if (!loyaltyService.loyaltyData.isRegister) {
						@if (loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) {
							<div class="mb-3">
								<div>{{ '_LOYALTY_REG.membership_expired_at' | translate }}
									:&nbsp;{{ loyaltyService.customer.customerMembershipExpire | date }}
								</div>
								@if (info.configurations.accountSettings?.isShowPointsBalanceInPos && info.balance.points) {
									<div>{{ '_LOYALTY.points_balance' | translate }}
										:&nbsp;{{ info.balance.points | number:'0.0-0' }}
									</div>
								}
							</div>
						}
						<div class="mb-3">{{ loyaltyService.loyaltyMember?.requiereOffersMessage | translate }}</div>
					}

					@if (loyaltyService.loyaltyData.isRegister && loyaltyService.loyaltyMember?.requiereOffersMessage) {
						<div class="mb-3 pre-wrap" >{{ loyaltyService.loyaltyMember.requiereOffersMessage | translate }}</div>
					}

					<div class="_bottom-actions d-flex align-items-center mt-3">
						@if (!data.disableDisconnect) {
							<button mat-button color="accent"
									(mousedown)="signOut()">{{ '_LOYALTY.signout' | translate }}
							</button>
						}
						<div class="flex-grow-1"></div>
						<button type="button" mat-flat-button color="accent" class="rounded"
								(mousedown)="continue()" *ngIf="!hasNext"
								style="min-width: 120px">{{ 'approve' | translate }}
						</button>
					</div>
				}
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--ACCOUNT-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				<ng-container *ngIf="wizardStep == stepsMap.account">
					<div *ngIf="info">
						<div class="_loyalty-info text-acc">
							<div *ngIf="loyaltyService.customer.birthDate">
								<mat-icon svgIcon="birthday" class="mr-1 base"></mat-icon>
								<span>{{loyaltyService.customer.birthDate | date}}</span>
							</div>

							<div *ngIf="loyaltyService.customer.cardNumber">
								<mat-icon svgIcon="lcard" class="mr-1 base"></mat-icon>
								<span>{{loyaltyService.customer.cardNumber | card}}</span>
							</div>
							<div *ngIf="loyaltyService.customer.mobile">
								<mat-icon svgIcon="mobile" class="mr-1 base" style="line-height: 12px;"></mat-icon>
								<span>{{loyaltyService.customer.mobile | phone}}</span>
							</div>
						</div>

						<!--START BALANCE-->
						@if (info.balance.visibility.pointsVisible || info.balance.visibility.compsVisible || info.balance.visibility.prepaidVisible || info.balance.visibility.pointsStoreVisible) {
							<div class="_loyalty-balance mb-3">
								<div *ngIf="info.balance.visibility.pointsVisible">
									<strong
										[class.text-lt]="info.balance.visibility?.pointsDisabled">{{ info.balance.cashBackPoints | number:decimalFormat }}</strong>
									<span>{{ info.pointsNickName || ('_LOYALTY.points_balance' | translate) }}</span>
								</div>
								<div *ngIf="info.balance.visibility.compsVisible">
									<strong>{{ info.balance.moneyCompensation | lcurrency }}</strong>
									<span>{{ '_LOYALTY.compensation' | translate }}</span>
								</div>
								<div *ngIf="info.balance.visibility.prepaidVisible">
									<strong>{{ info.balance.prePaid | lcurrency }}</strong>
									<span>{{ '_LOYALTY.card_balance' | translate }}</span>
								</div>
								<div *ngIf="info.balance.visibility.pointsStoreVisible">
									<strong
										[class.text-lt]="info.balance.visibility?.pointsDisabled">{{ ($storage.loyaltyOffersMap ? $storage.loyaltyOffersMap.remainingPoints : info.balance.pointsStorePoints) | number:decimalFormat }}</strong>
									<span>{{ info.pointsNickName || ('_LOYALTY.store_points' | translate) }}</span>
								</div>
							</div>
						}
						<!--END BALANCE-->

						@if ((loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) || loyaltyService.loyaltyMember.requiereOffersMessage) {
							<div class="alert alert-primary text-center">
								@if (loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) {
									<div>
										{{ '_LOYALTY_REG.membership_expired_at' | translate }}:&nbsp;{{ loyaltyService.customer.customerMembershipExpire | date }}
									</div>
								}
								@if (loyaltyService.loyaltyMember.requiereOffersMessage) {
									<div class="pre-wrap">
										{{ loyaltyService.loyaltyMember.requiereOffersMessage | translate }}
									</div>
								}
							</div>
						}
						<!--START_BENEFITS-->
						<!--start manual benefits-->
						@if (loyaltyService.loyaltyMember.$manualBenefits && appService.appConfig.envType == 'int') {
							<small class="text-danger mb-1" style="font-weight: 500; display: block">Manual benefits are still not implemented and are only displayed
								on int enviornments for Ori's testing purposes</small>
							<div >
								<div>{{ '_LOYALTY.select_benefits' | translate }}</div>
								<div class="_loyalty-manual-benefits"
									 [ngClass]="{_scroll: loyaltyService.loyaltyMember.$manualBenefits.length > 4}">

									@if (loyaltyService.loyaltyMember.$manualBenefits_limit[0]) {
										<div *ngIf="loyaltyService.loyaltyMember.$maxManualBenfits">
											<small>{{ appService.translate('_LOYALTY.select_benefits_max', {val: loyaltyService.loyaltyMember.$maxManualBenfits}) }}</small>
										</div>
										<div class="_cards">
											<div class="_card brand-accent-border"
												 [ngClass]="{'_active brand-accent': offer.active}"
												 *ngFor="let offer of loyaltyService.loyaltyMember.$manualBenefits_limit"
												 (click)="selectManualBenefit(offer)">
												<div>{{ offer.description }}</div>
											</div>
										</div>
									}
									@if (loyaltyService.loyaltyMember.$manualBenefits_unlimit[0]) {
										@if (loyaltyService.loyaltyMember.$manualBenefits_limit[0]) {
											<hr class="loyalty-hr"/>
											<div>{{ '_LOYALTY.select_additional_benefits' | translate }}</div>
										}
										<div class="_cards">
											<div class="_card brand-accent-border"
												 [ngClass]="{'_active brand-accent': offer.active}"
												 *ngFor="let offer of loyaltyService.loyaltyMember.$manualBenefits_unlimit"
												 (click)="selectManualBenefit(offer)">
												<div>{{ offer.description }}</div>
											</div>
										</div>
									}
								</div>
							</div>
						}
						<!--end manual benefits-->
						<!--start auto benefits-->
						<hr *ngIf="benefits && loyaltyService.loyaltyMember.$manualBenefits" class="loyalty-hr" />
						<div class="_loyalty-benefits mb-4" *ngIf="benefits">
							<div class="mb-2">{{'_LOYALTY.your_auto_benefits' | translate}}</div>
							<div class="_wrapper brand-accent-border mb-2">
								@for (offer of benefits; track offer) {
									<div class="_loyalty-benefit-row brand-accent-border">
										<mat-icon svgIcon="loyalty_benefit" class="mr-2"></mat-icon>
										<div class="_description">
											<div>{{ offer.description }}</div>
											<small *ngIf="offer.expired">
												{{ '_LOYALTY.expires' | translate }}:&nbsp;
												<strong>{{ offer.expired | date }}</strong>
											</small>
										</div>
									</div>
								}
							</div>
						</div>
						<!--end auto benefits-->
						<!--END_BENEFITS-->
						@if(loyaltyService.customer.requiereInvitation) {
							<p>{{'_LOYALTY_REG.sms_additional_info_sent_update' | translate}}</p>
						}
					</div>

					<div class="_bottom-actions d-flex align-items-center mt-3">
						@if (!data.disableDisconnect) {
							<button mat-button color="accent"
									(mousedown)="signOut()">{{ '_LOYALTY.signout' | translate }}
							</button>
						}
						<div class="flex-grow-1"></div>
						<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="continue()" *ngIf="!hasNext" style="min-width: 120px">{{'continue' | translate}}</button>
					</div>
				</ng-container>
			</mat-tab>
			<!------------------------------------------------------------------------------------->
			<!--POINTS-->
			<!------------------------------------------------------------------------------------->
			<mat-tab>
				<ng-container *ngIf="wizardStep == stepsMap.points">
					<div>

						<div class="points-subtitle">
							<div class="text-accent">
								<div>{{'_LOYALTY.points_balance' | translate}}:</div>
								<div>{{ui.pointsOptions.pointsBalance}}</div>
							</div>
							<div class="_strong" [ngClass]="{'button-shake-fast text-danger': ui.pointsOptions.invalid}">
								<div>{{'_LOYALTY.max_redeemable_points' | translate}}:</div>
								<div>{{ui.pointsOptions.maxVal}}</div>
							</div>

							<!--<div>
								<div>{{'total-order' | translate}}:</div>
								<div>{{$storage.order.grandTotal | lcurrency}}</div>
							</div>-->
						</div>
						<div class="keypad-val-container">
							<div class="keypad-val brand-input-border" [class._hasVal]="ui.pointsOptions.amountText?.length">
								<div class="_cap">{{'_LOYALTY.use_points' | translate}}</div>
								<div class="_val" style="font-size: 18px" [class.text-danger]="ui.pointsOptions.invalid">{{ui.pointsOptions.amountText}}</div>
							</div>
						</div>
						<app-inline-keypad [data]="ui.pointsOptions" (onChange)="onPointsChange($event)"></app-inline-keypad>
					</div>

					<div class="_bottom-actions d-flex align-items-center mt-3">
						<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
						<div class="flex-grow-1"></div>
						<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="applyPoints()"
								[class.loading]="loadingCustomer"
								[disabled]="ui.pointsOptions.invalid"
								style="min-width: 120px">{{'continue' | translate}}</button>
					</div>

				</ng-container>
			</mat-tab>
		</mat-tab-group>
	</div>
</form>





